// @flow

import styled, { css } from 'styled-components';
import {
  BRAND_PURPLE,
  BRAND_PURPLE_HOVER,
  INFO_BOX_BACKGROUND,
  ACCENT_PURPLE,
} from '../brand';

export { Container } from './success-screen.styles';

import {
  Content as BaseContent,
  Title as BaseTitle,
  Subtitle as BaseSubtitle,
  SubmitButton as BaseSubmitButton,
} from './success-screen.styles';

export const Content = styled(BaseContent)`
  align-items: stretch;
  max-width: 360px;
  margin: 0 auto;
  text-align: left;
`;

export const Avatar = styled.img`
  width: 56px;
  height: 56px;
  margin-bottom: 24px;
`;

export const Title = styled(BaseTitle)`
  margin-bottom: 12px;
  font-size: 28px;
  line-height: 1.15;
`;

export const Subtitle = styled(BaseSubtitle)`
  max-width: none;
  margin-bottom: 28px;
  color: ${props => props.theme.colors.neutral[700]};
  font-size: 15px;
  line-height: 1.6;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.colors.neutral[700]};
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  padding: 0 14px;
  border: 1px solid ${props => props.hasError ? props.theme.colors.feedback.error[500] : props.theme.colors.neutral[200]};
  border-radius: 8px;
  background: ${props => props.hasError ? props.theme.colors.feedback.error[100] : props.theme.colors.neutral.white};
  transition: border-color 0.2s, background-color 0.2s;

  &:focus-within {
    border-color: ${props => props.hasError ? props.theme.colors.feedback.error[500] : BRAND_PURPLE};
    ${props => !props.hasError && css`
      box-shadow: inset 0 0 0 1px ${BRAND_PURPLE};
    `}
  }
`;

export const CountryPrefix = styled.span`
  flex-shrink: 0;
  margin-right: 8px;
  color: ${props => props.theme.colors.neutral[700]};
  font-size: 15px;
  user-select: none;
`;

export const PhoneInput = styled.input`
  flex: 1;
  width: 100%;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: none;
  outline: none;
  font-size: 15px;
  color: ${props => props.hasError ? props.theme.colors.feedback.error[500] : props.theme.colors.neutral[700]};
  background: transparent;

  &::placeholder {
    color: ${props => props.theme.colors.neutral[300]};
  }
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const ErrorMessage = styled.span`
  margin-top: 6px;
  font-size: 13px;
  color: ${props => props.theme.colors.feedback.error[500]};
`;

export const InfoBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 24px 0;
  padding: 14px 16px;
  border-radius: 8px;
  background: ${INFO_BOX_BACKGROUND};
`;

export const InfoIcon = styled.span`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  color: ${props => props.theme.colors.neutral.white};
  background: ${ACCENT_PURPLE};
  font-size: 12px;
  font-weight: 700;
`;

export const InfoText = styled.p`
  font-size: 13px;
  line-height: 1.5;
  color: ${props => props.theme.colors.neutral[700]};
`;

export const InfoLink = styled.a`
  color: ${ACCENT_PURPLE};
  text-decoration: underline;
`;

export const SubmitButton = styled(BaseSubmitButton)`
  height: 44px;
  border-radius: 8px;
  font-size: 15px;
  color: ${props => props.disabled ? props.theme.colors.neutral[400] : props.theme.colors.neutral.white};
  background: ${props => props.disabled ? props.theme.colors.neutral[150] : BRAND_PURPLE};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};

  &:hover:not(:disabled) {
    background: ${BRAND_PURPLE_HOVER};
  }
`;
